import http from "../http-common";

const getAll = (params) => {
    return http.get("/actions", { params: params });
};

const get = (id) => {
    return http.get(`/actions/${id}`);
};


const create = data => {
    return http.post("/actions", data);
};

const update = (id, data) => {
    return http.put(`/actions/${id}`, data);
};

const remove = id => {
    return http.delete(`/actions/${id}`);
};

const removeAll = () => {
    return http.delete(`/actions`);
};

const findByTitle = title => {
    return http.get(`/actions?title=${title}`);
};

/**
 * Recupera le azioni filtrate per una data specifica e una sede.
 * @param {string} date - La data nel formato 'YYYY-MM-DD'.
 * @param {string|number} sede - L'identificativo della sede.
 * @returns {Promise<AxiosResponse<any>>}
 */
const findByDate = (date, sede) => {
    // Aggiungiamo il parametro sede alla query string
    return http.get(`/actions?date=${date}&sede=${sede}`);
}

// Questa funzione invia i dati al nuovo endpoint del backend.
const registerNFCActivity = data => {
    return http.post("/actions/nfc", data); // Corrisponde alla rotta '/api/actions/nfc'
}

const ActionService = {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findByTitle,
    findByDate,
    registerNFCActivity
};

export default ActionService;
